import { Controller } from "@hotwired/stimulus";

// The home page's search box shows only "Från" and "Vart vill du åka?" at
// desktop widths, and unfolds into the full form -- trip type, class, dates,
// travellers, the search button -- the first time someone clicks or tabs
// into it. Attached only there (ApplicationHelper#collapsible_searchfield?);
// step1's "Ändra sökning" panel renders the same partial whole.
//
// Everything it hides is hidden with `lg:hidden` rather than `hidden`, so
// the phone layout never collapses: there the whole form is stacked in one
// column already, and the user asked for desktop only.
//
// One-way: once the form is open it stays open. Re-collapsing on blur would
// mean a field disappearing out from under someone who clicked away to think
// about a date, and nothing here is expensive enough to be worth hiding
// again.
export default class extends Controller {
  static targets = ["collapsible", "grid"];

  expand() {
    if (this.expanded) return;
    this.expanded = true;

    this.collapsibleTargets.forEach((el) => el.classList.remove("lg:hidden"));

    // The field row is a 3-column grid at lg. With four of its six children
    // hidden, two fields across three columns left a third of the box empty,
    // so the collapsed form is a 2-column grid and this puts the third
    // column back. Swapped explicitly rather than by letting one class win
    // over the other: `important: true` makes both utilities !important, so
    // which of them applied would come down to their order in the compiled
    // stylesheet, not to anything stated here.
    this.gridTargets.forEach((el) => {
      el.classList.remove("lg:grid-cols-2");
      el.classList.add("lg:grid-cols-3");
    });
  }
}
